import { PackType, StreamEntityType } from 'types/enums';

export function getStreamEntityType(type: PackType): StreamEntityType {
    return type === PackType.RePack
        ? StreamEntityType.Repacks
        : StreamEntityType.Packs;
}
